/* eslint eqeqeq: 0 */
/* eslint-disable react/prop-types */import '../App.css';
import { fetchVideo} from '../Api';
import React, { useState, useEffect,useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
function getYouTubeVideoId(url) {
  try {
    const youtubeUrl = new URL(url);
    const hostname = youtubeUrl.hostname;
    const pathname = youtubeUrl.pathname;

    const isYouTubeLink =
      (hostname === 'www.youtube.com' || hostname === 'youtube.com') &&
      pathname === '/watch' &&
      youtubeUrl.searchParams.has('v');

    if (isYouTubeLink) {
      return youtubeUrl.searchParams.get('v');
    } else if (hostname === 'youtu.be' && pathname !== '/' && youtubeUrl.pathname.split('/').length === 2) {
      return youtubeUrl.pathname.split('/')[1];
    } else {
      return url;
    }
  } catch (error) {
    // console.error('Invalid YouTube URL');
    return url;
  }
}
const Article = ({show}) => {
  const [url, setUrl] = useState('')
  const [modal, setModal] = useState(false)
  const [data, setData] = useState([])
  const iframeRefs = useRef([])

  useEffect(() => {
    const getVideo = async () => {
      try {
        const data = await fetchVideo('jikoni')
        setData(data.results)
      } catch (error) {
        console.log(error)
      }
    }
    getVideo()
  }, [])

  return (
    <div style={{width:'100%',maxWidth:'100vw',overflow:'hidden'}}>
      {show !== false && (
        <div style={{ borderBottom: '2px solid #388E3C' }}>
          <div style={{ padding: 5, userSelect:'none',lineHeight: '20px', color: 'white', background: '#388E3C', width: 160 }}>Konnect Food+</div>
        </div>
      )}

      <div className='scrollable-container ' style={{display:'flex',flexDirection:'row',overflow:'auto',width:'100%',maxWidth:'100vw',background:'#f8f8f8',margin:5}}>
        {data.map((item,i) => (
          <div 
            key={i} 
            style={{ 
              display: 'flex', 
              flexDirection: 'row',
              padding: 5,
              width: '33%',
              minWidth: 300,
              maxWidth: 400,
              position: 'relative'
            }}
            onClick={() => {
              setUrl(item.video_id)
              setModal(true)
            }}
          >
            <div style={{ flex: 1 }}>
              <iframe
                style={{ minHeight: 230, minWidth: 290, width: '100%' }}
                src={`https://www.youtube.com/embed/${getYouTubeVideoId(item.video_id)}?rel=0&autoplay=0`}
                frameBorder="0"
                allowFullScreen
                title="Konnect Food+ Video"
                ref={(el) => (iframeRefs.current[i] = el)}
                onLoad={() => {
                  console.log('YouTube iframe loaded successfully')
                }}
              />
              <br />
              <h5 className="card-title card_title titlehover" style={{ color: 'black', fontSize: 16 }}>
                {item.title}
              </h5>
              <div className='truncate-text' style={{ fontSize: 14, color: 'gray' }}>
                {ReactHtmlParser(item.description)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div 
          style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            background: 'rgba(0,0,0,0.8)', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 1000 
          }}
          onClick={() => setModal(false)}
        >
          <div 
            style={{ 
              background: 'black',
              width: '95%',
              maxWidth: 800,
              minWidth: 360,
              height: '50vw',
              maxHeight: 400,
              zIndex: 51,
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              style={{ 
                minHeight: 230,
                width: '100%',
                minWidth: 300,
                height: '100%' 
              }}
              src={`https://www.youtube.com/embed/${getYouTubeVideoId(url)}?rel=0&autoplay=0`}
              frameBorder="0"
              allowFullScreen
              title="Konnect Food+ Video"
            />
          </div>
        </div>
      )}
    </div>
  )
}
export default Article;